/* BTF — LVLS build v2. Menu, quick add, filters, sort, product page, price box. */
(() => {
  'use strict';

  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
  const fmt = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  };

  /* ---------- Toast ---------- */
  let toastEl;
  const toast = (msg) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'btf-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  };

  /* ---------- Cart count + free shipping lines ---------- */
  const shipText = (el, total) => {
    const threshold = Math.round(parseInt(el.dataset.threshold, 10) * rate);
    const left = threshold - total;
    el.dataset.total = total;
    if (el.matches('[data-btf-ship-line]')) {
      el.innerHTML = left > 0 ? `You're ${fmt(left)} away from <strong>free shipping</strong>` : '<strong>Free shipping unlocked</strong>';
      return;
    }
    const text = el.querySelector('[data-btf-ship-text]');
    const fill = el.querySelector('[data-btf-ship-fill]');
    if (fill) fill.style.width = Math.max(0, Math.min(100, (total / threshold) * 100)) + '%';
    el.classList.toggle('is-done', left <= 0);
    el.dataset.drawn = '1';
    if (text) text.textContent = left <= 0 ? el.dataset.doneLabel || 'Free shipping unlocked' : `You're ${fmt(left)} away from free shipping`;
  };
  const refreshCart = async () => {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.querySelectorAll('.btf-cart-count').forEach((n) => (n.textContent = cart.item_count));
      document.querySelectorAll('[data-btf-ship], [data-btf-ship-line]').forEach((el) => shipText(el, cart.items_subtotal_price));
    } catch (e) {}
  };

  /* ---------- Add to cart (base theme drawer / notification / cart page) ---------- */
  const addToCart = async (variantId, quantity = 1) => {
    const drawer = document.querySelector('cart-drawer');
    const notification = document.querySelector('cart-notification');
    const target = drawer || notification;
    const fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', quantity);
    if (target && typeof target.getSectionsToRender === 'function') {
      fd.append('sections', target.getSectionsToRender().map((s) => s.section || s.id).join(','));
      fd.append('sections_url', window.location.pathname);
      if (typeof target.setActiveElement === 'function') target.setActiveElement(document.activeElement);
    }
    const res = await fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd,
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
    if (window.publish && window.PUB_SUB_EVENTS) {
      try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'btf', productVariantId: variantId, cartData: data }); } catch (e) {}
    }
    if (target && typeof target.renderContents === 'function' && data.sections) {
      target.renderContents(data);
      if (drawer) drawer.classList.remove('is-empty');
    } else {
      toast('Added to cart');
    }
    refreshCart();
    return data;
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-btf-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    try { await addToCart(btn.dataset.btfQuickAdd, 1); } catch (err) { toast(err.message); }
    finally { btn.classList.remove('is-loading'); }
  });

  /* Drop card buy bar */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-btf-buybar-select]');
    if (!sel) return;
    const price = sel.selectedOptions[0] && sel.selectedOptions[0].dataset.price;
    const out = sel.closest('form').querySelector('[data-btf-buybar-price]');
    if (price && out) out.textContent = price;
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-btf-buybar]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button');
    btn.disabled = true;
    try { await addToCart(form.querySelector('select').value, 1); } catch (err) { toast(err.message); }
    finally { btn.disabled = false; }
  });

  /* ---------- Menu drawer ---------- */
  const initMenu = (menu) => {
    const close = () => { menu.open = false; document.body.style.overflow = ''; };
    menu.addEventListener('toggle', () => { document.body.style.overflow = menu.open ? 'hidden' : ''; });
    menu.querySelectorAll('[data-btf-menu-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.open) close(); });
    const country = menu.querySelector('[data-btf-country] select');
    if (country) country.addEventListener('change', () => country.form.submit());
  };

  /* ---------- Filter pills + sort ---------- */
  const initTabs = (root) => {
    const tabs = [...root.querySelectorAll('.btf-pill-tab[role="tab"]')];
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') select(tabs[(i + 1) % tabs.length], true);
        if (e.key === 'ArrowLeft') select(tabs[(i - 1 + tabs.length) % tabs.length], true);
      });
    });
    const sort = root.querySelector('[data-btf-sort]');
    if (sort) {
      root.querySelectorAll('[data-btf-sortable]').forEach((ul) => [...ul.children].forEach((li, i) => (li.dataset.i = i)));
      sort.addEventListener('change', () => {
        root.querySelectorAll('[data-btf-sortable]').forEach((ul) => {
          const items = [...ul.children];
          const v = sort.value;
          items.sort((a, b) => {
            if (v === 'price-asc') return a.dataset.price - b.dataset.price;
            if (v === 'price-desc') return b.dataset.price - a.dataset.price;
            if (v === 'name') return a.dataset.name.localeCompare(b.dataset.name);
            return a.dataset.i - b.dataset.i;
          });
          items.forEach((li) => ul.appendChild(li));
        });
      });
    }
  };

  /* ---------- Price box countdown ---------- */
  const initRise = (el) => {
    const end = parseInt(el.dataset.deadline, 10) * 1000;
    const clock = el.querySelector('[data-btf-clock]');
    const pad = (n) => String(n).padStart(2, '0');
    let timer;
    const tick = () => {
      const ms = end - Date.now();
      if (ms <= 0) { el.hidden = true; clearInterval(timer); return; }
      const t = Math.floor(ms / 1000);
      const d = Math.floor(t / 86400);
      const hms = `${pad(Math.floor((t % 86400) / 3600))}:${pad(Math.floor((t % 3600) / 60))}:${pad(t % 60)}`;
      clock.textContent = d > 0 ? `${d}d ${hms}` : hms;
    };
    timer = setInterval(tick, 1000);
    tick();
  };

  /* ---------- Product page ---------- */
  const initProduct = (root) => {
    const json = root.querySelector('[data-btf-variants]');
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const low = parseInt(root.dataset.low, 10) || 5;
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const input = root.querySelector('[data-btf-variant-input]');
    const fieldsets = [...root.querySelectorAll('[data-btf-option]')];
    const atc = root.querySelector('[data-btf-atc]');
    const atcLabel = root.querySelector('[data-btf-atc-label]');
    const stock = root.querySelector('[data-btf-stock]');
    const error = root.querySelector('[data-btf-error]');
    const priceNow = root.querySelector('[data-btf-price-now]');
    const priceWas = root.querySelector('[data-btf-price-was]');
    const chip = root.querySelector('[data-btf-price-chip]');
    const ladderNow = root.querySelector('[data-btf-ladder-now]');
    const dynamic = root.querySelector('[data-btf-dynamic]');
    const notify = root.querySelector('[data-btf-notify]');
    const sticky = root.querySelector('[data-btf-sticky]');
    const stickyBtn = root.querySelector('[data-btf-sticky-btn]');
    const stickyPrice = root.querySelector('[data-btf-sticky-price]');
    const gallery = root.querySelector('[data-btf-gallery]');
    const counter = root.querySelector('[data-btf-count]');

    const selected = () => fieldsets.map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });

    const mark = (sel) => {
      fieldsets.forEach((fs, i) => {
        fs.querySelectorAll('.btf-opt__value').forEach((lab) => {
          const val = lab.querySelector('input').value;
          const ok = variants.some((v) => v.available && v.options[i] === val && v.options.every((o, j) => j === i || sel[j] === null || o === sel[j]));
          lab.classList.toggle('is-unavailable', !ok);
        });
      });
    };

    const setStock = (v) => {
      stock.classList.remove('btf-stock--low', 'btf-stock--out');
      if (!v) { stock.textContent = 'Unavailable'; stock.classList.add('btf-stock--out'); return; }
      if (!v.available) { stock.textContent = 'Sold out'; stock.classList.add('btf-stock--out'); return; }
      if (v.inv !== null && v.inv > 0 && v.inv <= low) { stock.textContent = `Only ${v.inv} left`; stock.classList.add('btf-stock--low'); return; }
      stock.textContent = 'In stock';
    };

    const goToMedia = (id) => {
      if (!id || !gallery) return;
      const fig = gallery.querySelector(`[data-media-id="${id}"]`);
      if (!fig) return;
      if (window.matchMedia('(max-width: 989px)').matches) gallery.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
      else window.scrollTo({ top: fig.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    };

    const update = (fromUser) => {
      const sel = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      mark(sel);
      setStock(v);
      if (error) error.textContent = '';
      const can = !!(v && v.available);
      atc.disabled = !can;
      atcLabel.textContent = !v ? 'Unavailable' : v.available ? 'Add to cart' : 'Sold out';
      if (stickyBtn) stickyBtn.textContent = atcLabel.textContent;
      if (dynamic) dynamic.hidden = !can;
      if (notify) notify.hidden = !(v && !v.available);
      if (!v) return;
      input.value = v.id;
      priceNow.textContent = fmt(v.price);
      if (ladderNow) ladderNow.textContent = fmt(v.price).replace(/\.00$/, '');
      if (stickyPrice) stickyPrice.textContent = fmt(v.price);
      if (v.compare > v.price) {
        priceWas.hidden = false; priceWas.textContent = fmt(v.compare);
        chip.hidden = false; chip.textContent = `-${Math.floor(((v.compare - v.price) * 100) / v.compare)}%`;
      } else {
        priceWas.hidden = true; chip.hidden = true;
      }
      if (fromUser) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        goToMedia(v.media);
      }
    };
    fieldsets.forEach((fs) => fs.addEventListener('change', () => update(true)));
    update(false);

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (atc.disabled) return;
      const label = atcLabel.textContent;
      atc.disabled = true;
      atcLabel.textContent = 'Adding…';
      try { await addToCart(input.value, 1); }
      catch (err) { if (error) error.textContent = err.message; }
      finally { atcLabel.textContent = label; update(false); }
    });

    /* Details "view more" */
    const clamp = root.querySelector('[data-btf-clamp]');
    const more = root.querySelector('[data-btf-more]');
    if (clamp && more) {
      requestAnimationFrame(() => {
        if (clamp.scrollHeight > clamp.clientHeight + 8) {
          more.hidden = false;
          more.addEventListener('click', () => {
            const open = clamp.classList.toggle('is-open');
            more.textContent = open ? 'View less' : 'View more';
          });
        } else {
          clamp.classList.add('is-open');
        }
      });
    }

    /* Mobile swipe counter */
    if (gallery && counter) {
      let raf;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => { counter.textContent = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1; });
      }, { passive: true });
    }

    /* Sticky bar: shows once the main button scrolls away */
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', !show);
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
      stickyBtn.addEventListener('click', () => {
        if (!atc.disabled) form.requestSubmit ? form.requestSubmit() : atc.click();
        else root.querySelector('.btf-buy').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* Sticky columns that are taller than the screen stick by their bottom edge, so nothing is cut off */
    const stickCols = () => {
      const headerH = (document.querySelector('.btf-header') || { offsetHeight: 64 }).offsetHeight;
      root.querySelectorAll('.btf-pdp__info, .btf-pdp__buy').forEach((col) => {
        col.style.setProperty('--btf-stick', Math.min(headerH, window.innerHeight - col.offsetHeight) + 'px');
      });
    };
    stickCols();
    window.addEventListener('resize', stickCols);
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(stickCols);
      root.querySelectorAll('.btf-pdp__info, .btf-pdp__buy').forEach((c) => ro.observe(c));
    }

    /* Size guide */
    const dlg = root.querySelector('[data-btf-sizeguide]');
    const openBtn = root.querySelector('[data-btf-open-sizeguide]');
    if (dlg && openBtn && typeof dlg.showModal === 'function') {
      openBtn.addEventListener('click', () => dlg.showModal());
      root.querySelector('[data-btf-close-sizeguide]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    }
  };

  /* ---------- Boot ---------- */
  const boot = (scope = document) => {
    scope.querySelectorAll('[data-btf-menu]').forEach(initMenu);
    scope.querySelectorAll('[data-btf-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-btf-rise]').forEach(initRise);
    scope.querySelectorAll('[data-btf-product]').forEach(initProduct);
    if (rate !== 1) document.querySelectorAll('[data-btf-ship], [data-btf-ship-line]').forEach((el) => shipText(el, parseInt(el.dataset.total, 10) || 0));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));

  /* Keep counts right when the drawer changes quantities */
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => { if (!ev || ev.source !== 'btf') refreshCart(); }); } catch (e) {}
  }
  if (rate !== 1) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(() => drawer.querySelectorAll('[data-btf-ship]:not([data-drawn])').forEach((b) => shipText(b, parseInt(b.dataset.total, 10) || 0))).observe(drawer, { childList: true, subtree: true });
  }
})();
